import { Badge, IconButton } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/sharedHooks";
import { NotificationsState } from "../models/notificationModels";
import { togglePanel, fetchUnreadCount } from "../notificationsSlice";
import NotificationIcon from "../../icons/NotificationIcon";
import NotificationPanel from "./NotificationPanel";
import useNotificationHub from "../hooks/useNotificationHub";

const NotificationBell: React.FC = () => {
  const dispatch = useAppDispatch();
  const { unreadCount } = useAppSelector<NotificationsState>(
    (state: any) => state.notifications
  );
  const bellRef = useRef<HTMLButtonElement>(null);

  // Initialize SignalR connection
  useNotificationHub();

  // Fetch initial unread count
  useEffect(() => {
    dispatch(fetchUnreadCount());
  }, [dispatch]);

  const handleToggle = () => {
    dispatch(togglePanel());
  };

  return (
    <>
      <IconButton ref={bellRef} onClick={handleToggle} sx={{ marginLeft: "40px" }}>
        <Badge
          badgeContent={unreadCount}
          color="error"
          max={99}
          invisible={unreadCount === 0}
        >
          <NotificationIcon />
        </Badge>
      </IconButton>

      <NotificationPanel anchorEl={bellRef.current} />
    </>
  );
};

export default NotificationBell;
